import { Ayah } from '@app-types/KuranTypes'
import { useUserData } from '@contexts/UserDataContext'
import { getSurahAnchorId } from 'helpers/surahAnchor'
import React from 'react'

type MealGroup = {
  ayahs: Ayah[]
  startIndex: number
}

function groupAyahsByMeal(ayahs: Ayah[], mealSource: string): MealGroup[] {
  const groups: MealGroup[] = []

  ayahs.forEach((ayah, index) => {
    const mealText = ayah[mealSource as keyof Ayah] as string
    const lastGroup = groups[groups.length - 1]

    if (
      lastGroup &&
      !ayah.zero &&
      mealText === (lastGroup.ayahs[0][mealSource as keyof Ayah] as string)
    ) {
      lastGroup.ayahs.push(ayah)
    } else {
      groups.push({ ayahs: [ayah], startIndex: index })
    }
  })

  return groups
}

const QuranMealPage = ({ ayahs }: { ayahs: Ayah[] }) => {
  const { userData } = useUserData()
  const mealSource = userData.kuranMealSource || 'muhtasar_tefsir'
  const groups = groupAyahsByMeal(ayahs, mealSource)

  return (
    <div>
      {groups.map((group, i) => (
        <MealPart key={i} group={group} mealSource={mealSource} />
      ))}
    </div>
  )
}

export default QuranMealPage

type MealPartProps = {
  group: MealGroup
  mealSource: string
}

const MealPart = ({ group, mealSource }: MealPartProps) => {
  const firstAyah = group.ayahs[0]
  const lastAyah = group.ayahs[group.ayahs.length - 1]
  const mealText = firstAyah[mealSource as keyof Ayah] as string

  const verseLabel =
    group.ayahs.length > 1
      ? `${firstAyah.verse_number}-${lastAyah.verse_number}`
      : `${firstAyah.verse_number}`

  return (
    <>
      {firstAyah.zero && (
        <>
          <div
            id={getSurahAnchorId(firstAyah.surah.id)}
            className="scroll-mt-32 px-4 py-2 my-2 text-lg tracking-wider rounded-full bg-slate-200 dark:bg-slate-700"
          >
            {firstAyah.surah.name} Suresi | {firstAyah.surah.verse_count} Ayet{' '}
          </div>
          <p className="text-xl italic">Rahman ve Rahim olan Allah'ın adıyla</p>
        </>
      )}
      <p data-ayah-id={group.startIndex} className="py-2 text-lg ayah-id">
        {verseLabel}: {mealText}
      </p>
    </>
  )
}
